import { FC } from 'react';
import { decomposeJson } from '../decomposeJson';
import { decomposeNestedTable } from '../decomposeNestedTable';
import { DecomposeMethod } from '../types';

import { TreeViewContext, TreeViewState } from './TreeViewContext';

export type ContextProps = {
  collapseByDefault?: boolean;
  highlight?: string;
  sort?: boolean;
  tableColor?: string;
  altRowColorDepth?: number;
  showBranchFocus?: boolean;
  isNestedTable?: boolean;
};

export const TreeViewContextProvider: FC<React.PropsWithChildren<ContextProps>> = ({
  collapseByDefault = false,
  children,
  highlight,
  sort = false,
  tableColor,
  altRowColorDepth,
  showBranchFocus = false,
  isNestedTable = false,
}) => {
  const contextValue: TreeViewState = {
    collapseByDefault,
    highlight,
    sort,
    tableColor,
    decompose: (isNestedTable ? decomposeNestedTable : decomposeJson) as DecomposeMethod,
    isNestedTable,
    altRowColorDepth,
    showBranchFocus,
  };

  return <TreeViewContext.Provider value={contextValue}>{children}</TreeViewContext.Provider>;
};
